import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import {PromoBanner} from '@/models';
import { ui } from '@/constants';
import { CountryCode } from '@/store/ui';

@Component({
  name: 'CmgNooHomePage',
})
export default class CmgNooHomePage extends Vue {
  @Prop({ type: Object })
  promoBanner?: PromoBanner;

  @Prop({ type: Boolean })

  interval: any;

  mounted() {
    this.interval = setInterval(this.resizeIframe, 1000);
  } 
  destroyed() {    
    clearInterval(this.interval);
  }

  get isDesktop(): boolean {
    return this.$appStore.state.ui.clientWidth > ui.breakpoints.tabletMax;
  }

  get isLoggedIn(): boolean {
    return this.$services.customer.isLoggedIn() === true;
  }

  get countryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  get promoBannerTopAuthenticatedDesktop(): string | undefined {
    if(this.countryCode == CountryCode.CA) {
      return this.$appStore.state.cms.promoBannerTopAuthenticatedDesktopCanada?.nooHomePageURL;
    }
    return this.$appStore.state.cms.promoBannerTopAuthenticatedDesktop?.nooHomePageURL;
  }

  get promoBannerTopAuthenticatedMobile(): string | undefined {
    if(this.countryCode == CountryCode.CA) {
      return this.$appStore.state.cms.promoBannerTopAuthenticatedMobileCanada?.nooHomePageURL;
    }
    return this.$appStore.state.cms.promoBannerTopAuthenticatedMobile?.nooHomePageURL;
  }

  get promoBannerTopGuestDesktop(): string | undefined {
    if(this.countryCode == CountryCode.CA) {
      return this.$appStore.state.cms.promoBannerTopGuestDesktopCanada?.nooHomePageURL;
    }
    return this.$appStore.state.cms.promoBannerTopGuestDesktop?.nooHomePageURL;
  }

  get promoBannerTopGuestMobile(): string | undefined {
    if(this.countryCode == CountryCode.CA) {
      return this.$appStore.state.cms.promoBannerTopGuestMobileCanada?.nooHomePageURL;
    }
    return this.$appStore.state.cms.promoBannerTopGuestMobile?.nooHomePageURL;
  }
  
  get nooHomePage(): string | undefined {
    let url = window.location.origin;
    if(this.isLoggedIn) {
      if(this.isDesktop) {
        return url + this.promoBannerTopAuthenticatedDesktop;
      } else {
        return url + this.promoBannerTopAuthenticatedMobile;
      }
    } else {
      if(this.isDesktop) {
        return url + this.promoBannerTopGuestDesktop;
      } else {
        return url + this.promoBannerTopGuestMobile;
      }
    }
  }

  resizeIframe() {
    const iframe = this.$refs.iframe as HTMLIFrameElement;
    const iframeContainer = this.$refs.iframeContainer as HTMLElement;
    if (iframe && iframe.contentWindow) {
      if(iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
        const height = iframe.contentWindow.document.documentElement.offsetHeight + 'px';
        iframe.style.height = height;
        iframeContainer.style.height = height;
      }
    }
  }
}
